var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchieveLastingImpactSectionImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1271px",
    height: "140px",
    viewBox: "0 0 1271 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "achieve-lasting-impact-section-image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZH.Screen.Web.Home",
    transform: "translate(-160, -4478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "achieve-lasting-impact-section-image",
    transform: "translate(170, 4488)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 60,
    x2: 1259,
    y2: 60,
    id: "Line",
    stroke: "#10575D",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    fill: "#348389",
    cx: 60,
    cy: 60,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "search-sort-svgrepo-com",
    transform: "translate(30, 43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7044344,6.65993147 C20.8605761,12.6270378 21.6107672,20.464147 26.5160413,25.5874691 C31.3423479,30.6389055 39.1070964,31.4288724 44.8450129,27.4526149 C46.0512024,26.6191279 47.1265537,25.6092292 48.0346797,24.4567245 C48.927709,23.3232599 49.6539002,22.0670066 50.1908016,20.7264331 C51.2924754,17.9726231 51.5773777,14.9580814 51.0114441,12.045734 C50.4544136,9.1598096 49.0713214,6.49991751 47.0321024,4.39067084 C45.0234639,2.30605963 42.4365047,0.876308864 39.6076108,0.287350245 C36.7899427,-0.29057293 33.8638879,0.0076561004 31.2192515,1.1422087 C28.549841,2.29067218 26.2814614,4.21165571 24.7044344,6.65993147 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5.76773872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7363515,22.0973152 C48.4407429,21.1491995 46.6244908,21.435577 45.6803649,22.7365162 C44.736239,24.0374553 45.0215284,25.8602467 46.3175241,26.8079739 L49.7363515,22.0973152 Z M55.3871715,33.4408984 C56.6827801,34.3886255 58.4990322,34.1026365 59.4431581,32.8016974 C60.387284,31.5007582 60.1019946,29.6779669 58.8059989,28.7302397 L55.3871715,33.4408984 Z M10.6451261,18.4567839 C12.2485143,18.4567839 13.5483423,17.1523476 13.5483423,15.5424937 C13.5483423,13.9330284 12.2485143,12.6282035 10.6451261,12.6282035 L10.6451261,18.4567839 Z M2.9032162,12.6282035 C1.29982796,12.6282035 -1.21125332e-13,13.9330284 -1.21125332e-13,15.5424937 C-1.21125332e-13,17.1523476 1.29982796,18.4567839 2.9032162,18.4567839 L2.9032162,12.6282035 Z M10.6451261,30.1139447 C12.2485143,30.1139447 13.5483423,28.8095084 13.5483423,27.1996545 C13.5483423,25.5901891 12.2485143,24.2853643 10.6451261,24.2853643 L10.6451261,30.1139447 Z M2.9032162,24.2853643 C1.29982796,24.2853643 -1.21125332e-13,25.5901891 -1.21125332e-13,27.1996545 C-1.21125332e-13,28.8095084 1.29982796,30.1139447 2.9032162,30.1139447 L2.9032162,24.2853643 Z M14.516081,6.79977854 C16.1194692,6.79977854 17.4192972,5.49499254 17.4192972,3.88548835 C17.4192972,2.27598416 16.1194692,0.971198153 14.516081,0.971198153 L14.516081,6.79977854 Z M2.9032162,0.971198153 C1.29982796,0.971198153 -1.21125332e-13,2.27598416 -1.21125332e-13,3.88548835 C-1.21125332e-13,5.49499254 1.29982796,6.79977854 2.9032162,6.79977854 L2.9032162,0.971198153 Z M46.3175241,26.8079739 L55.3871715,33.4408984 L58.8059989,28.7302397 L49.7363515,22.0973152 L46.3175241,26.8079739 Z M10.6451261,12.6282035 L2.9032162,12.6282035 L2.9032162,18.4567839 L10.6451261,18.4567839 L10.6451261,12.6282035 Z M10.6451261,24.2853643 L2.9032162,24.2853643 L2.9032162,30.1139447 L10.6451261,30.1139447 L10.6451261,24.2853643 Z M14.516081,0.971198153 L2.9032162,0.971198153 L2.9032162,6.79977854 L14.516081,6.79977854 L14.516081,0.971198153 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(420, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    fill: "#348389",
    cx: 60,
    cy: 60,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com",
    transform: "translate(35, 33)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1091667,34.8663648 C17.5066667,34.2831 22.2319444,39.5470579 24.3531944,41.9100916 L24.3534722,41.9103666 C24.61,42.1960866 24.8283333,42.4394573 25,42.6248041 C25.2475,42.3742835 25.58875,42.0055149 25.9986111,41.5624977 L25.9986111,41.5624977 C28.2805556,39.0964783 32.6902778,34.3310867 34.8908333,34.8663648 C42.3965278,36.6923329 50,40.4156302 50,46.0167322 L50,55 L0,55 L0,46.0167322 C0,40.4156302 7.60347222,36.6923329 15.1091667,34.8663648 Z M38.8888889,43.99923 L41.6666667,43.99923 L41.6666667,46.7491819 L38.8888889,46.7491819 L38.8888889,49.4991338 L36.1111111,49.4991338 L36.1111111,46.7491819 L33.3333333,46.7491819 L33.3333333,43.99923 L36.1111111,43.99923 L36.1111111,41.2492781 L38.8888889,41.2492781 L38.8888889,43.99923 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7343056,1.91048782 C17.3231944,1.10328069 21.4797222,0 25,0 C28.5202778,0 32.6768056,1.10328069 35.2655556,1.91048782 C37.5584722,2.62542031 38.6023611,5.09896077 37.7472222,7.21536498 L34.6229167,16.3228893 C34.3423611,17.0171147 33.5529167,17.3622337 32.8456944,17.0996133 C27.6045833,15.1538848 22.3954167,15.1538848 17.1543056,17.0996133 C16.4470833,17.3622337 15.6576389,17.0171147 15.3770833,16.3228893 L12.2527778,7.21536498 C11.3976389,5.09896077 12.4415278,2.62542031 14.7343056,1.91048782 Z M26.3888889,6.87487969 L29.1666667,6.87487969 L29.1666667,9.62483157 L26.3888889,9.62483157 L26.3888889,12.3747834 L23.6111111,12.3747834 L23.6111111,9.62483157 L20.8333333,9.62483157 L20.8333333,6.87487969 L23.6111111,6.87487969 L23.6111111,4.12492781 L26.3888889,4.12492781 L26.3888889,6.87487969 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5695833,14.7805788 C16.5488889,16.5461854 15.2777778,19.1250903 15.2777778,21.999615 C15.2777778,27.315272 19.6305556,31.6244466 25,31.6244466 C30.3694444,31.6244466 34.7222222,27.315272 34.7222222,21.999615 C34.7222222,19.1250903 33.4511111,16.5461854 31.4304167,14.7805788 L33.2686111,12.7188024 C35.8613889,14.9843503 37.5,18.3034047 37.5,21.999615 C37.5,28.8339329 31.9036111,34.3743984 25,34.3743984 C18.0963889,34.3743984 12.5,28.8339329 12.5,21.999615 C12.5,18.3034047 14.1386111,14.9843503 16.7313889,12.7188024 L18.5695833,14.7805788 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(840, 0)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 10,
    fill: "#348389",
    cx: 60,
    cy: 60,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "speed-alt-svgrepo-com",
    transform: "translate(35, 35)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32234179,43 C3.82603303,39.4770409 1.44500433,34.9890385 0.480380365,30.1027393 C-0.484243602,25.2167549 0.0108183681,20.1519305 1.90300384,15.5494138 C3.79518931,10.9467712 6.99949838,7.01282648 11.110744,4.24505708 C15.2219583,1.47728767 20.0552969,0 24.9999791,0 C29.9446613,0 34.7780936,1.47728767 38.8893392,4.24505708 C43.0005848,7.01282648 46.2046439,10.9467712 48.0968294,15.5494138 C49.9890148,20.1519305 50.4843268,25.2167549 49.5196403,30.1027393 C48.5549539,34.9890385 46.1740189,39.4770409 42.6777727,43",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.9999791,
    y1: 25.1887324,
    x2: 37.4999657,
    y2: 18.8915493,
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieveLastingImpactSectionImage);
export default __webpack_public_path__ + "static/media/achieve-lasting-impact-section-image.6e954acbfba07f9c325a084429d188f3.svg";
export { ForwardRef as ReactComponent };